import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { selectIsAuthenticated, selectUserLoaded } from "@/features/auth";
import { useAppSelector } from "@/shared/store/hooks";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const userLoaded = useAppSelector(selectUserLoaded);
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  // Aguarda decriptação do user do localStorage antes de decidir
  if (!userLoaded) return null;

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
